module.exports = __webpack_public_path__ + "static/media/vehicle-damage-report-step-img.39e6411e.svg";